import React from 'react';
import {Container, Row} from 'reactstrap';
import PopupHeadlineComponent from './PopupSharedComponents/PopupHeadlineComponent';
import PopupDescriptionComponent from './PopupSharedComponents/PopupDescriptionComponent';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderSmallSize from '../../../Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import PopupImageComponent from './PopupSharedComponents/PopupImageComponent';
import './IsInterestedToBuyFromOrg.scss';

const InterestedToBuyFromOrgPopup = (props) => {
  return (
    <Container className='InterestedToBuyInOrgPopup'>
      <PopupImageComponent icon={require('./images/lampIcon/lamp.svg')} />
      <PopupHeadlineComponent title={''} />
      <PopupDescriptionComponent boldDescription={'האם להתקין את החבילה על חשבון החברה?'} />
      <Row className='buttonsRow'>
        <BtnSubmit
          text={'כן, על חשבון החברה'}
          onclick={() => {
            props.setBuyInSplit(true);
          }}
        />
        <BtnWhiteBlackBorderSmallSize
          text={'לא, על חשבון העובד'}
          onclick={() => {
            props.setBuyInSplit(false);
          }}
        />
      </Row>
    </Container>
  );
};
export default InterestedToBuyFromOrgPopup;
